import { IPublicEnumDragObjectType } from '@gant-lowcode/lowcode-types';
import { isObject } from './is-object';
export function isDragAnyObject(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return obj.type !== IPublicEnumDragObjectType.NodeData && obj.type !== IPublicEnumDragObjectType.Node;
}